import axios from 'axios';
import axiosInstance from './axiosInstance';

const apiBase = () => process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';

/**
 * Issue a scoped ingest JWT for the extension (Story 2.4).
 * @param {{ deviceId: string }} body
 */
export async function issueExtensionIngestToken(body) {
  const { data } = await axiosInstance.post('/extension/tokens', body);
  return data;
}

/**
 * Provision the extension from the website session (AD-EA-1).
 *
 * Send `jti` only when the extension's token is genuinely still alive — the
 * backend answers `{ reused: true }` and issues nothing, so a healthy extension
 * session survives dashboard navigation untouched (AD-EA-2).
 *
 * @param {{ deviceId: string, jti?: string|null, tokenVersion?: number|null }} params
 */
export async function getExtensionSession({ deviceId, jti, tokenVersion }) {
  const params = { deviceId };
  if (jti) params.jti = jti;
  if (tokenVersion != null) params.tokenVersion = tokenVersion;
  const { data } = await axiosInstance.get('/extension/session', { params });
  return data;
}

/**
 * Refresh ingest JWT — must send the ingest Bearer token (not the web session JWT).
 * @param {string} ingestToken
 */
export async function refreshExtensionIngestToken(ingestToken) {
  const { data } = await axios.post(
    `${apiBase()}/extension/tokens/refresh`,
    {},
    { headers: { Authorization: `Bearer ${ingestToken}`, 'Content-Type': 'application/json' } }
  );
  return data;
}

/**
 * Revoke by device or all devices.
 * @param {{ deviceId?: string, all?: boolean }} body
 */
export async function revokeExtensionIngestToken(body) {
  const { data } = await axiosInstance.post('/extension/tokens/revoke', body);
  return data;
}
